import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/in/order";

export default {
    /** 分页查询入库单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询入库单详情（含明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存入库单（草稿） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除入库单 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
}
